export const mockCart = {
  token: 'a295dc7be2345e56f0f204535fa59cb5',
  note: null,
  attributes: {},
  original_total_price: 20000,
  total_price: 20000,
  total_discount: 0,
  total_weight: 0.0,
  item_count: 2,
  items: [
    {
      id: 42053137268895,
      properties: {},
      quantity: 1,
      variant_id: 42053137268895,
      key: '42053137268895:6a8bdabe65dc1ef971a785859ac9bd43',
      title: 'Hat',
      price: 10000,
      original_price: 10000,
      discounted_price: 10000,
      line_price: 10000,
      original_line_price: 10000,
      total_discount: 0,
      discounts: [],
      sku: '',
      grams: 0,
      vendor: 'kevdevkev',
      taxable: true,
      product_id: 7353890078879,
      product_has_only_default_variant: true,
      gift_card: false,
      final_price: 10000,
      final_line_price: 10000,
      url: '/products/hat?variant=42053137268895',
      featured_image: {
        aspect_ratio: 1.0,
        alt: 'Hat',
        height: 612,
        url: 'https://cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhat.jpg?v=1649088731',
        width: 612
      },
      image:
        'https://cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhat.jpg?v=1649088731',
      handle: 'hat',
      requires_shipping: true,
      product_type: '',
      product_title: 'Hat',
      product_description: 'This hat is the best',
      variant_title: null,
      variant_options: ['Default Title'],
      options_with_values: [
        {
          name: 'Title',
          value: 'Default Title'
        }
      ],
      line_level_discount_allocations: [
        {
          amount: 500,
          discount_application: {
            type: 'script',
            key: 'a8a3d7aa-7d00-4827-a2e1-b03c32160bf2',
            title: '5 Dollar Off',
            description: null,
            value: '5.00',
            created_at: '2019-04-10T20:49:10.023Z',
            value_type: 'fixed_amount',
            allocation_method: 'one',
            target_selection: 'explicit',
            target_type: 'line_item',
            total_allocated_amount: 500
          }
        }
      ],
      line_level_total_discount: 0
    },
    {
      id: 42053112332447,
      properties: {},
      quantity: 1,
      variant_id: 42053112332447,
      key: '42053112332447:f14f6a9febd4bb9926426a5c9e0146ee',
      title: 'Hoodie - Large',
      price: 10000,
      original_price: 10000,
      discounted_price: 10000,
      line_price: 10000,
      original_line_price: 10000,
      total_discount: 0,
      discounts: [],
      sku: '',
      grams: 0,
      vendor: 'kevdevkev',
      taxable: true,
      product_id: 7353880051871,
      product_has_only_default_variant: false,
      gift_card: false,
      final_price: 10000,
      final_line_price: 10000,
      url: '/products/hoodie?variant=42053112332447',
      featured_image: {
        aspect_ratio: 1.0,
        alt: 'Hoodie',
        height: 700,
        url: 'https://cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhoodie.webp?v=1649088670',
        width: 700
      },
      image:
        'https://cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhoodie.webp?v=1649088670',
      handle: 'hoodie',
      requires_shipping: true,
      product_type: '',
      product_title: 'Hoodie',
      product_description: 'This hoodie is so soft',
      variant_title: 'Large',
      variant_options: ['Large'],
      options_with_values: [{ name: 'Size', value: 'Large' }],
      line_level_discount_allocations: [],
      line_level_total_discount: 0
    }
  ],
  requires_shipping: true,
  currency: 'USD',
  items_subtotal_price: 20000,
  cart_level_discount_applications: []
};
